<template>
	<div>
		<!-- <MyBread v-bind:BreadcrumbList="BreadcrumbList"></MyBread> -->
		<Form ref="SelectParam" :model="SelectParam" inline style="text-align: left;margin-top: 1%;">
			<FormItem prop="trackName" :label="$tt('价格名称:')" :label-width="100">
				<Input type="text" v-model="SelectParam.Name" :placeholder="$tt('价格名称')" />
			</FormItem>
			<FormItem>
				<Button type="primary" @click="handleSearch('SelectParam')" v-if="hasWidgets('search')">{{$tt('查询')}}</Button>
			</FormItem>
			<div style="float: right;">
				<Button type="primary" @click="showModal('modal_add')" v-if="hasWidgets('add')">{{$tt('添加价格')}}</Button>
				<!-- <Button style="float: left;margin-left: 5px;" type="primary" @click="show('addExcel')">{{$tt('批量导入')}}</Button> -->
			</div>
		</Form>
		<Table :columns="tableColumns" :data="tableData" :height="tableHeight" size="small"></Table>
		<MyPage ref="sonPage" :param="SelectParam" :url="getOccupyPriceListUrl" @listData='getTableData'></MyPage>
		<Modal :mask-closable="false" v-model="modalView" :title="$tt('新增价格')" width="400">
			<Form label-position="right" :rules="ruleInline" ref="PriceForm" :model="PriceForm" :label-width="150">
				<FormItem :label="$tt('价格名称')" prop="Name">
					<Input v-model="PriceForm.Name" :placeholder="$tt('输入价格名称')"></Input>
				</FormItem>
				<FormItem :label="$tt('冻结金额')" prop="FreezeAmount">
					<Input v-model="PriceForm.FreezeAmount" :placeholder="$tt('输入冻结金额')"></Input>
				</FormItem>
				<FormItem :label="$tt('免费时长(分钟)')" prop="FreeDuration">
					<Input v-model="PriceForm.FreeDuration" :placeholder="$tt('输入免费时长,单位:分钟')"></Input>
				</FormItem>
				<FormItem :label="$tt('计费价格(元/周期)')" prop="PeriodPrice">
					<Input v-model="PriceForm.PeriodPrice" :placeholder="$tt('输入计费价格')"></Input>
				</FormItem>
				<FormItem :label="$tt('计费周期(分钟)')" prop="PeriodInterval">
					<Input v-model="PriceForm.PeriodInterval" :placeholder="$tt('计费周期,单位:分钟')"></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="warning" size="large" @click="modalCancel">{{$tt('重置')}}</Button>
				<Button type="success" size="large" @click="modalOk('add')">{{$tt('新增')}}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import webapi from '../../../webapi.js';
	export default {
		data() {
			return {
				getOccupyPriceListUrl: webapi.base_api_url + '/Archives/GetOccupyPriceTemplateList',
				//查询组件的参数
				SelectParam: {},
				loadingStatus: false,
				tableHeight: "650",
				BreadcrumbList: [this.$tt('档案管理'), '>>', this.$tt('价格管理')],
				modalView: false,
				//table标题数据
				tableColumns: [ {
						title: this.$tt('价格名称'),
						key: 'Name',
						minWidth: 120,
					}, {
						title: this.$tt('免费时长(分钟)'),
						key: 'FreeDuration',
						minWidth: 100,
					}, {
						title: this.$tt('冻结金额(元)'),
						key: 'FreezeAmount',
						minWidth: 100,
					}, {
						title: this.$tt('计费周期(分钟)'),
						key: 'PeriodInterval',
						minWidth: 100,
					}, {
						title: this.$tt('计费价格(元/周期)'),
						key: 'PeriodPrice',
						minWidth: 100,
					}
				],
				tableData: [],
				ruleInline: {
					Name: [{
						required: true,
						message: this.$tt('请输入价格名称'),
						trigger: 'blur'
					}],
				},
				defaultPrice: {
					Name: '',
					FreezeAmount: 0,
					FreeDuration: 0,
					PeriodPrice: 0,
					PeriodInterval: 1
				},
				PriceForm: {}
			};
		},
		created() {
			const _this = this;
			_this.tableHeight = window.innerHeight - 220;
			window.addEventListener('resize', this.getTableHeight)
		},
		destroyed() {
			window.removeEventListener("resize", this.getTableHeight);
		},
		mounted() {
			this.$nextTick(() => {
				this.handleSearch();
			})
		},
		computed: {
		},
		methods: {
			hasWidgets: function(widgetName) {
				return this.$route.meta.widgets.find(w => w.Name == widgetName);
			},
			/******************组件固定方法*************************/
			showModal: function(type, params) {
				this.PriceForm = Object.assign({}, this.defaultPrice);
				this.modalView = true;
			},
			getTableData: function(data) {
				if (!this.hasWidgets('search')) return;
				console.log(data)
				this.tableData = data.Data.List
			},
			handleSearch: function() {
				if (!this.hasWidgets('search')) return;
				this.$refs.sonPage.getList();
			},
			getTableHeight: function() {
				this.tableHeight = window.innerHeight - 220;
			},
			modalCancel: function() {
				this.PriceForm = Object.assign({}, this.defaultPrice);
			},
			modalOk: function() {
				this.$axios.post(webapi.base_api_url + '/Archives/AddOccupyPriceTemplate', this.PriceForm).then(res => {
					if (res.data.Code == 0) {
						this.$Message.info(this.$tt('添加成功'));
						this.handleSearch();
					}
				})
			}
		},
	}
</script>

<style>
	/* 	#tree{
		width: 1200px;
		height: 600px;
		margin-top: 7%;
		border: 2px solid red;
	} */

	.ivu-tag-dot {
		border: 0px solid #e8eaec !important;
	}

	.ivu-form-item {
		margin-bottom: 10px;
	}

	.ivu-col-span-7 {
		margin-left: 2%;
	}

	.demo-upload-list {
		display: inline-block;
		width: 60px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		border: 1px solid transparent;
		border-radius: 4px;
		overflow: hidden;
		background: #fff;
		position: relative;
		box-shadow: 0 1px 1px rgba(0, 0, 0, .2);
		margin-right: 4px;
	}

	.demo-upload-list img {
		width: 100%;
		height: 100%;
	}

	.demo-upload-list-cover {
		display: none;
		position: absolute;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		background: rgba(0, 0, 0, .6);
	}

	.demo-upload-list:hover .demo-upload-list-cover {
		display: block;
	}

	.demo-upload-list-cover i {
		color: #fff;
		font-size: 20px;
		cursor: pointer;
		margin: 0 2px;
	}
</style>
